import { render } from "./BalAlert.vue?vue&type=template&id=946232c0"
import script from "./BalAlert.vue?vue&type=script&lang=ts"
export * from "./BalAlert.vue?vue&type=script&lang=ts"

import "./BalAlert.vue?vue&type=style&index=0&id=946232c0&lang=css"
script.render = render

export default script